import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import EntityForm from "@/components/probaworkflows_base_components/OnboardingForms/EntityForm/EntityForm.vue";
import { get_headers, GET_PROFILE_COMPLETION_ID } from '@/utils/constants/constants';
import alert_mixin from "@/utils/mixins/alert_mixin";
import axios from 'axios';

export default {
  name: 'ApplicationOverview',
  mixins: [alert_mixin],

  components: {
    NavigationBackButton,
    EntityForm,
  },

  props: {
    application_form_id: {
      type: [String, Number],
      default: null,
    }
  },

  data: () => ({
      progressPercentage: 50, // default
      stepsRemaining: 3,
      application_id: '',
      active_tab: '',
      tabs: [],
      requests: [],
      dropdown_expanded: false,
      steps: [
        { date: "04 Mar", title: "Onboarding", status: "completed" },
        { date: "05 Mar", title: "Manual verification", status: "in-progress" },
        { date: "06 Mar", title: "Auto verification", status: "pending" },
        { date: "06 Mar", title: "Compliance", status: "pending" },
      ],
      form_name: '',
      profile_completion_loading: false,
      profile_completion: {
        total_questions: 0,
        answered_questions: 0,
        unanswered_questions: 0,
        completion_percentage: 0,
      },
  }),

  mounted() {
    this.application_id = sessionStorage.getItem('application_id');
    this.form_name = sessionStorage.getItem('selected_form_name');

    if (this.form_name) {
      this.tabs = [this.form_name];
      this.active_tab = this.form_name;
    }

    this.fetch_profile_completion();
  },

  watch: {
    application_form_id(newVal) {
      if (newVal) {
        this.fetch_profile_completion();
      }
    }
  },

  methods: {
    set_active_tab(tab) {
      this.active_tab = tab;
    },

    redirect_to_requested_information() {
      this.$router.push({
        path: '/requested_information_update',
      });
    },

    redirect_to_auto_verification_overview() {
      this.$router.push({
        path: '/auto_verification_overview',
      });
    },

    fetch_profile_completion() {
      const application_form_id = Number(this.application_form_id) || Number(sessionStorage.getItem("application_form_id"));
      if (!application_form_id) return;

      this.profile_completion_loading = true;

      axios.get(GET_PROFILE_COMPLETION_ID, {
        headers: get_headers(),
        params: { application_form_id },
      })
      .then((response) => {
        if (response.data?.status === 'success' && response.data?.data) {
          this.profile_completion = { ...response.data.data };
        } else {
          this.show_error('Unexpected response from profile completion API:', response.data);
        }
      })
      .catch((error) => {
        this.show_error(
          'Error fetching profile completion:',
          error.response?.data?.message || error.message
        );
      })
      .finally(() => {
        this.profile_completion_loading = false;
      });
    },
  }
};